<template>
  <div class="action">
    <button @click="button1Action" :class="[page === '1' ? 'btn-cancel' : '']">
      {{ button1String }}
    </button>
    <button
      :disabled="disabled"
      @click="button2Action"
      :class="[page === '4' ? 'btn-nonrounded blink' : '']"
      class="btn-active"
    >
      {{ button2String }}
    </button>
  </div>
</template>

<script>
export default {
  name: "demandActionButton",
  props: {
    page: {
      type: String,
      required: true,
    },
    button1String: {
      type: String,
      required: true,
    },
    button1Action: {
      type: Function,
      required: true,
    },
    button2String: {
      type: String,
      required: true,
    },
    button2Action: {
      type: Function,
      required: true,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.action {
  width: 95%;
  margin: 0 auto 10px;
  button {
    width: 49.5%;
    height: 40px;
    border: none;
    background: #e0e0e0;
    font-weight: bold;
  }
  button:first-child {
    margin-right: 1%;
    background: #e0e0e0;
    color: black;
    border-radius: 50px 0px 0px 50px / 50px 0px 0px 50px;
  }
  button:last-child {
    border-radius: 0px 50px 50px 0px / 0px 50px 50px 0px;
  }
  button:disabled {
    background: #f0f0f0;
    color: #bebebe;
  }
  .btn-cancel {
    border-radius: 5px 0px 0px 5px / 5px 0px 0px 5px !important;
  }
  .btn-nonrounded {
    border-radius: 0px 5px 5px 0px / 0px 5px 5px 0px !important;
  }
  .btn-active {
    background: #fdb206;
    color: white;
  }
}
.blink {
  animation: blinkAnime 1s infinite alternate;
}
@keyframes blinkAnime {
  0% {
    color: #ffffff;
  }
  100% {
    color: red;
  }
}
</style>
